import { render, staticRenderFns } from "./EvaluateRulesAdd.vue?vue&type=template&id=55c55cee&scoped=true&"
import script from "./EvaluateRulesAdd.vue?vue&type=script&lang=js&"
export * from "./EvaluateRulesAdd.vue?vue&type=script&lang=js&"
import style0 from "./EvaluateRulesAdd.vue?vue&type=style&index=0&id=55c55cee&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c55cee",
  null
  
)

export default component.exports